"use client";

import React from "react";
import svgPaths from "@/assets/svg/svg-5s97axwnwx";
import { Loader2 } from "lucide-react";

export default function MobileCTAButton({
	onClick,
	isUpgrading,
}: {
	onClick?: () => void;
	isUpgrading?: boolean;
}) {
	return (
		<button
			type="button"
			data-testid="try-free-transform-section-button"
			onClick={onClick}
			disabled={isUpgrading}
			className="w-full bg-[#a7ff5e] text-[#12301b] rounded-full py-4 px-8 flex items-center justify-center gap-2 font-extrabold text-sm shadow-lg mb-8 border border-[#dde3e9] disabled:opacity-70 disabled:cursor-not-allowed"
		>
			<svg className="w-6 h-6 shrink-0" fill="none" viewBox="0 0 24 24">
				{isUpgrading ? (
					<foreignObject width="24" height="24">
						<div className="flex items-center justify-center w-full h-full">
							<Loader2 className="w-5 h-5 animate-spin" />
						</div>
					</foreignObject>
				) : (
					<path d={svgPaths.p21cafcf0} fill="#1C1B1F" />
				)}
			</svg>
			<span>
				{isUpgrading ? "Redirecting..." : "Try Free for 14 days"}
			</span>
		</button>
	);
}
